import { render, staticRenderFns } from "./AdminEmail.vue?vue&type=template&id=dcf496e8"
import script from "./AdminEmail.vue?vue&type=script&lang=js"
export * from "./AdminEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports